<p>{{ 'pricelists.ui.pricelistsDetailWorks' | transloco }}</p>
